import { render, staticRenderFns } from "./veSbzcJzwRoomcateEdit.vue?vue&type=template&id=6466708a&scoped=true"
import script from "./veSbzcJzwRoomcateEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwRoomcateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466708a",
  null
  
)

export default component.exports